import script from "./Feeds.vue?vue&type=script&setup=true&lang=js"
export * from "./Feeds.vue?vue&type=script&setup=true&lang=js"

import "./Feeds.vue?vue&type=style&index=0&id=696525d4&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-696525d4"]])

export default __exports__